import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Button from '@components/Shared/Buttons/Button';
import { getSlug, isUrlInternal, formatHttpsUrl } from '@utils/utils';

import { LocationsContext } from '@contexts/LocationsContext';

import { CuratedButtonStyles } from './CuratedButton.styled';

import ChevronRightSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-right.svg';

const CuratedButton = ({ info, className }) => {
  const locationsContext = useContext(LocationsContext);
  const iconUrl =
    info && info.collectionIcon && info.collectionIcon.url
      ? formatHttpsUrl(info.collectionIcon.url)
      : null;
  const iconAltTag =
    info && info.collectionIcon && info.collectionIcon.description
      ? info.collectionIcon.description
      : '';
  const title = info && info.collectionTitle ? info.collectionTitle : '';
  const buttonUrl =
    (info && info.slug ? info.slug : null) +
    (locationsContext.state && `?zip=${locationsContext.state.postalCode}`);

  return (
    <CuratedButtonStyles className={`curated-button ${className}`}>
      <Button
        className={'inner-button'}
        isCompact={true}
        fillContainer={true}
        onDarkBg={true}
        nextJSUrl={isUrlInternal(buttonUrl) ? getSlug(buttonUrl) : buttonUrl}
        linkComponent={isUrlInternal(buttonUrl) ? Link : null}
      >
        <div className="info-standard">
          <div className="icon-img">
            <div className="icn">
              <Image alt={iconAltTag} src={`${iconUrl}?w=30`} fill />
            </div>
          </div>
          <div className="info-text">
            <p className="label large">{title}</p>
          </div>
          <div className="info-standard-chevron">
            <ChevronRightSvg />
          </div>
        </div>

        <div className="info-compact">
          <div className="info-compact-block">
            <div className="icon-img">
              <div className="icn">
                <Image alt={iconAltTag} src={`${iconUrl}?w=30`} fill />
              </div>
            </div>
            <div className="info-text">
              <p className="label large">{title}</p>
            </div>
          </div>
          <div className="info-compact-chevron">
            <ChevronRightSvg />
          </div>
        </div>
      </Button>
    </CuratedButtonStyles>
  );
};

CuratedButton.propTypes = {
  className: PropTypes.any,
  info: PropTypes.shape({
    collectionIcon: PropTypes.shape({
      description: PropTypes.any,
      url: PropTypes.any,
    }),
    collectionTitle: PropTypes.any,
    slug: PropTypes.any,
  }),
};

export default CuratedButton;
